import React, { useState } from "react";
import AgencyTree from './agencyTree/AgencyTree';
import HoteTree from "./hoteTree/hoteTree";
import CommercantTree from "./commercantTree/commercantTree";
import RenterTree from "./renterTree/renterTree";

export default function StepThree(props) {
    const [render, setRender] = useState(true);

    if(render){
        setDatas();
        setRender(false);
    }

    function getTree(){
        
        switch(props.datas.type){
            case 'agence':
                return <AgencyTree handleChange={props.handleChange} datas={props.datas} prev={props.prev} next={props.next}/>
            case 'hôte':
                return <HoteTree handleChange={props.handleChange} datas={props.datas} prev={props.prev} next={props.next}/>
            case 'commerçant':
                return <CommercantTree handleChange={props.handleChange} datas={props.datas} prev={props.prev} next={props.next}/>
            case 'loueur':
                return <RenterTree handleChange={props.handleChange} datas={props.datas} prev={props.prev} next={props.next}/>
        }
    }

    function setDatas(){
        let datas = Object.assign({}, props.datas);
        switch(props.datas.type){
            case 'agence':
                datas = {
                    ...datas,
                    lengthRent: {
                        '1-3d': 5,
                        '3-6d': 5,
                        '1-3w': 5,
                        '1-*m': 5,
                    },
                    periodRent: {
                        summer: 5,
                        outSummer: 5,
                        holidays: 5,
                        weekend: 5,
                    },
                    profilRent: {
                        businessCustomers: 5,
                        vacationers: 5,
                        familly: 5,
                        friends: 5,
                        couple: 5,
                        alone: 5,
                        '-25': 5,
                        '25-30': 5,
                        '30-50': 5,
                        '+50': 5,
                    },
                    behaviours: {
                        ownHome: 5,
                        notOwnHome: 5
                    }
                }
            case 'hôte':
                datas = {
                    ...datas,
                    lengthRent: {
                        '1-3d': 5,
                        '3-6d': 5,
                        '1-3w': 5,
                        '1-*m': 5,
                    },
                    periodRent: {
                        summer: 5,
                        outSummer: 5,
                        holidays: 5,
                        weekend: 5,
                    },
                    profilRent: {
                        businessCustomers: 5,
                        vacationers: 5,
                        familly: 5,
                        friends: 5,
                        couple: 5,
                        alone: 5,
                        '-25': 5,
                        '25-30': 5,
                        '30-50': 5,
                        '+50': 5,
                    },
                    behaviours: {
                        ownHome: 5,
                        notOwnHome: 5
                    }
                }
            case 'commerçant':
                datas = {
                    ...datas,
                    periodRent: {
                        summer: 5,
                        outSummer: 5,
                        holidays: 5,
                        weekend: 5,
                    },
                    profilRent: {
                        businessCustomers: 5,
                        vacationers: 5,
                        familly: 5,
                        friends: 5,
                        couple: 5,
                        alone: 5,
                        '-25': 5,
                        '25-30': 5,
                        '30-50': 5,
                        '+50': 5,
                    }
                }
            case 'loueur':
                datas = {
                    ...datas,
                    lengthRent: {
                        '1-3d': 5,
                        '3-6d': 5,
                        '1-3w': 5,
                        '1-*m': 5,
                    },
                    periodRent: {
                        summer: 5,
                        outSummer: 5,
                        holidays: 5,
                        weekend: 5,
                    },
                    profilRent: {
                        businessCustomers: 5,
                        vacationers: 5,
                        familly: 5,
                        friends: 5,
                        couple: 5,
                        alone: 5,
                        '-25': 5,
                        '25-30': 5,
                        '30-50': 5,
                        '+50': 5,
                    },
                    behaviours: {
                        ownHome: 5,
                        notOwnHome: 5
                    }
                }
        }
        props.handleChange(datas);
    }

    return (
        <>
            {
                getTree()
            }
        </>
    )
}